import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BeerConsumptionService {

  constructor() { }

  getMaxConsumptionDay(data: any[]): { day: string, d: string, m: string, y: string, total: number, details: any } {
    const consumoPorDia: { [key: string]: { total: number, detalles: { [key: string]: number }, d: string, m: string, y: string } } = {};
    data.forEach(entry => {
      const fechaKey = `${entry.year}-${String(entry.month).padStart(2, '0')}-${String(entry.day).padStart(2, '0')}`;
      const fecha = new Date(entry.year, entry.month - 1, entry.day); // Meses en JS van de 0 a 11
      const diaSemana = fecha.toLocaleDateString('es-ES', { weekday: 'long' }); // Día en español
      const d = String(entry.day).padStart(2, '0');
      const m = String(entry.month).padStart(2, '0');
      const y = String(entry.year);

      const consumoTotal: any = Object.values(entry.beertypes).reduce((sum, beer: any) => sum + beer.consume, 0);
      if (!consumoPorDia[fechaKey]) {
        consumoPorDia[fechaKey] = { total: 0, detalles: {}, d: d, m: m, y: y  };
      }
      
      consumoPorDia[fechaKey].total += consumoTotal;

      Object.values(entry.beertypes).forEach((beer: any) => {
        if (!consumoPorDia[fechaKey].detalles[beer.type]) {
          consumoPorDia[fechaKey].detalles[beer.type] = 0;
        }
        consumoPorDia[fechaKey].detalles[beer.type] += beer.consume;
      });
    });
    
    if(Object.keys(consumoPorDia).length != 0){
      const diaMax = Object.keys(consumoPorDia).reduce((max, key) =>
        consumoPorDia[key].total > consumoPorDia[max].total ? key : max
      );
      const fechaMax = new Date(`${consumoPorDia[diaMax].y}-${consumoPorDia[diaMax].m}-${consumoPorDia[diaMax].d}`);
      const nombreDia = fechaMax.toLocaleDateString('es-ES', { weekday: 'long' });
      return {
        day: nombreDia,
        d: consumoPorDia[diaMax].d,
        m: consumoPorDia[diaMax].m,
        y: consumoPorDia[diaMax].y,
        total: consumoPorDia[diaMax].total,
        details: consumoPorDia[diaMax].detalles
      }; 
    }else{
      return {
        day: "",
        d: "",
        m: "",
        y: "",
        total: 0,
        details: ""
      }; 
    }
  }
}
